module.exports = __webpack_public_path__ + "static/img/icon_star_legend@2x.fae7f12e.png";